export default {
  // Hero
  bookHeroLabel: 'Direct booking',
  bookHeroTitle: 'Check availability.\nBook directly.',
  bookHeroText: 'Choose your preferred dates, check available rooms and book at the best rate – with no detours.',

  // Booking system
  bookSystemTitle: 'Book online',
  bookSystemSub: 'Real-time availability & instant confirmation',
  bookPhoneLabel: 'By phone:',
  bookNoRoom: 'No room available? We often still have options for stays of 3 nights or more.',
  bookNoRoomLink: 'Get in touch with us directly.',

  // Notes
  bookNotesTitle: 'Good to know',
  bookNote1: 'Check-in from 3 pm',
  bookNote2: 'Check-out until 12 noon',
  bookNote3: 'Breakfast 7 – 10 am, weekends/holidays 8 – 11 am',
  bookNote4: 'Free parking',
  bookNote5: 'Complimentary Wi-Fi',
  bookNote6: 'Pets are not permitted',

  // Rooms overview
  bookRoomsTitle: 'Our room categories',
  bookRoom1Name: 'Double room',
  bookRoom1Details: '2 guests',
  bookRoom1Price: 'from €179',
  bookRoom2Name: 'Single room',
  bookRoom2Details: '1 guest',
  bookRoom2Price: 'from €99',
  bookRoom3Name: 'Comfort double room',
  bookRoom3Details: '30 m² · 2 guests',
  bookRoom3Price: 'from €199',

  // Advice
  bookAdviceTitle: 'Need advice?',
  bookAdviceText: 'Give us a call or send a message – we are happy to help you choose.',
};
